<template>
	<div>
		<h3 class="mb-6">Your submission has been sent. Thank you for your interest.</h3>
	</div>
</template>

<script>
export default {
	name: "step-three",
};
</script>

<style lang="sass" scoped>
</style>